import { AssetIcon } from 'assets/icons/AssetIcon';
import cx from 'classnames';
import { isEqualVal } from 'helpers/string.helper';
import { map, size } from 'lodash';
import React, { HTMLAttributes, ReactElement, useState } from 'react';
import { Swiper, SwiperClass, SwiperProps, SwiperSlide } from 'swiper/react';
import './carousel.css';

export type Props = SwiperProps & {
  setCarousel?: (c: SwiperClass) => void;
  slides: Array<number | string | ReactElement>;
  hiddenDot?: boolean;
  hiddenBtn?: boolean;
  RenderSlide?: (i: any, ind: number) => ReactElement;
  OuterProps?: HTMLAttributes<HTMLDivElement>;
};

export const Carousel: React.FC<Props> = ({
  setCarousel,
  slides,
  hiddenDot,
  hiddenBtn = true,
  RenderSlide,
  OuterProps,
  ...rest
}: any): any => {
  const [swiper, setSwiper] = useState<SwiperClass | null>(null);
  const [activeSlideIndex, setActiveSlideIndex] = useState(0);

  const handleSlideTo = (index: number) => {
    setActiveSlideIndex(index);
    swiper && swiper.slideToLoop(index);
  };

  const handleNewsPrev = () => {
    swiper && swiper.slidePrev();
  };

  const handleNewsNext = () => {
    swiper && swiper.slideNext();
  };

  return (
    <div
      {...OuterProps}
      className={cx('pb-carousel-wrapper', OuterProps?.className)}
    >
      {!hiddenBtn && size(slides) > 1 && (
        <button
          type="button"
          className="pb-carousel-arrow pb-carousel-arrow-left"
          onClick={handleNewsPrev}
        >
          <AssetIcon.Next2Icon />
        </button>
      )}
      {!hiddenBtn && size(slides) > 1 && (
        <button
          type="button"
          className="pb-carousel-arrow pb-carousel-arrow-right"
          onClick={handleNewsNext}
        >
          <AssetIcon.Next2Icon />
        </button>
      )}
      <Swiper
        {...rest}
        className={cx('pb-carousel', rest?.className)}
        spaceBetween={50}
        scrollbar={{ draggable: true }}
        onSwiper={setCarousel || setSwiper}
        onRealIndexChange={(swiperData) =>
          setActiveSlideIndex(swiperData?.realIndex || 0)
        }
        freeMode={false}
        loop
      >
        {map(slides, (item, index) => (
          <SwiperSlide className="swiper-slide">
            {RenderSlide?.(item, index)}
          </SwiperSlide>
        ))}
      </Swiper>
      {!hiddenDot && size(slides) > 1 && (
        <ul className="pb-carousel-indicators">
          {map(slides, (_, index: number) => (
            <button
              type="button"
              onClick={() => handleSlideTo(index)}
              key={index}
              className={`${
                isEqualVal(activeSlideIndex, index) ? 'active' : ''
              }`}
            >
              {isEqualVal(activeSlideIndex, index) ? (
                <AssetIcon.DotActiveIcon />
              ) : (
                <AssetIcon.DotIcon />
              )}
            </button>
          ))}
        </ul>
      )}
    </div>
  );
};
